import { render, staticRenderFns } from "./contact-dialog.vue?vue&type=template&id=59331c30&"
import script from "./contact-dialog.vue?vue&type=script&lang=js&"
export * from "./contact-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports